/* unplugin-vue-components disabled */import script from "./Scene.vue?vue&type=script&setup=true&lang=js"
export * from "./Scene.vue?vue&type=script&setup=true&lang=js"

import "./Scene.vue?vue&type=style&index=0&id=dcd07906&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dcd07906"]])

export default __exports__